import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

import { CrossIcon, PinDateIcon } from 'assets/v2/icons';
import { DATE_FORMAT } from 'utils/constants';

import { DateChipWrapper } from './DateChip.styles';

const DateChip = ({ value, onDelete, disabled, ...rest }) => {
  const label = useMemo(() => {
    const dateValue = DateTime.fromISO(value);
    if (dateValue.isValid) return dateValue.toFormat(DATE_FORMAT);
    return value;
  }, [value]);

  return (
    <DateChipWrapper
      label={label}
      onDelete={onDelete}
      {...rest}
      deleteIcon={<CrossIcon />}
      icon={<PinDateIcon />}
    />
  );
};

DateChip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
};

export default memo(DateChip);
